var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('dashboard-head'), _c('dashboard-body', {
    staticClass: "mt-40 mt-lg-100"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }